@if (field?.state$ | async) {
  <div class="mb-10 flex flex-col font-sans text-xl">
    <label>{{ label }}*</label>
    @if (field.counties.length > 1) {
      <mat-select
        placeholder="Please Select"
        [value]="field.selectedFips"
        [disabled]="form.disabled"
        [attr.aria-label]="label"
        (selectionChange)="field.select($event.value)"
      >
        @for (county of field.counties; track county.countyFIPS) {
          <mat-option [value]="county.countyFIPS">{{ county.countyName }} ({{ county.state.abbreviation }})</mat-option>
        }
      </mat-select>
      <span class="text-base">Please select your county from the list above</span>
    } @else {
      <input
        [value]="countyControl.value || ''"
        [placeholder]="placeholder"
        [attr.aria-label]="label"
        class="w-full border-none text-2xl outline-none"
        readonly
      />
    }
    @if (field.state.status === 'loading') {
      <mat-progress-bar mode="indeterminate" />
    }
    @if (field.error) {
      <span class="text-base text-red-800">{{ field.error }}</span>
    }
    @if (field.state.status === 'lookupFailed') {
      <button
        type="button"
        class="mt-1 cursor-pointer self-start border-0 bg-transparent p-0 text-sm text-[#2c67ff] underline underline-offset-2 disabled:cursor-default disabled:text-gray-500"
        [disabled]="form.disabled"
        (click)="field.retry()"
      >
        Retry county lookup
      </button>
    }
  </div>
}
